$(document).ready(function () {
    // console.log('ready');
    const eventName = $("#event-name");
    const bibNo = $("#bib-no");
    const bibDiv = $("#index-bib-home-div");
    const eventForm = $("#event-form");
    const resultDiv = $("#result-div");
    const loadingDiv = $("#loading-div");
    const userDiv1 = $("#userDiv1");
    const userDiv2 = $("#userDiv2");
    const imgElement = $("#userflag");
    let debounceTimeout;
    let debounceTimeout2;
    let cachedEventList = null;
    let lastSearchedEvent = "";
    let cachedParticipantList = null;
    let lastSearchedParticipant = "";
    let autocompleteInitialized = false;
    const params = new URLSearchParams(window.location.search);
    let EVENT_ID = '';
    let EVENT_NAME = '';

    let URL_SLUG = '';
    var urlSlug = params.get('q');
    if (urlSlug) {
        const decodedSlug = atob(urlSlug);
        const urlData = JSON.parse(decodedSlug);
        EVENT_ID = urlData.e_id;
        EVENT_NAME = urlData.e_name;
        if (EVENT_ID && EVENT_NAME) {
            bibDiv.removeClass("index-bib-home");
        }
    }
    eventName.val(EVENT_NAME);
    // console.log(eventName, bibNo);

    function eventNameAutoComplete() {
        if (autocompleteInitialized && eventName.autocomplete("instance")) {
            eventName.autocomplete("destroy");
        }
        eventName.autocomplete({
            source: function (request, response) {
                eventName.css("color", "black");

                let inputValue = eventName.val().trim();
                if (cachedEventList && inputValue === lastSearchedEvent) {
                    response(cachedEventList);
                    return;
                }
                axios.get('frontend/api/event/live-result/event-search', {
                    params: {
                        name: inputValue
                    }
                }).then(res => {
                    // var data = res.data;
                    let decodedData = atob(res.data.data);
                    let data = JSON.parse(decodedData);

                    cachedEventList = data.events.length === 0 ? [{ label: "No Events Found", value: null }] : data.events.map(event => ({
                        label: event.highlight ? event.highlight : event.name,
                        value: event.event_id,
                        plainText: event.name
                    }));
                    lastSearchedEvent = inputValue;
                    response(cachedEventList);
                    $(".ui-autocomplete").each(function () {
                        $(this).toggleClass("ac-scroll-enabled", cachedEventList.length > 5);
                    });
                }).catch(error => {
                    console.error("API call error:", error);
                    response([]);
                    // alert('Something Went Wrong');
                    Swal.fire({
                        icon: 'error',
                        title: 'Something Went Wrong',
                        // text: text,
                    });
                });
            },
            minLength: 3,
            autoFocus: false,
            focus: function (event, ui) {
                eventName.val(ui.item.plainText);
                return false;
            },
            open: function () {
                var parentWidth = eventName.outerWidth();
                $("ul.ui-menu").width(parentWidth);
            },
            select: function (event, ui) {
                EVENT_ID = ui.item.value;
                eventName.val(ui.item.plainText);
                eventName.css("color", "rgb(0, 71, 171)");
                bibDiv.removeClass("index-bib-home");
                bibNo.focus();
                return false;
            }
        });

        eventName.autocomplete("instance")._renderItem = function (ul, item) {
            return $("<li>")
                .append($("<div>").html(item.label))
                .appendTo(ul);
        };

        autocompleteInitialized = true;

        eventName.autocomplete("search", eventName.val());
    }

    function setEventNameAutoComplete() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            if (eventName.val().length >= 3) {
                eventNameAutoComplete();
            }
        }, 0);
    }

    eventName.on("input", () => {
        EVENT_ID = null;
        setEventNameAutoComplete();
    });

    eventName.on("focus", () => {
        if (cachedEventList && cachedEventList.length > 0) {
            eventName.autocomplete("option", "source", function (request, response) {
                response(cachedEventList);
            });
            eventName.autocomplete("search", eventName.val());
            return;
        }
        setEventNameAutoComplete();
    });

    function setRunnerNameAutoComplete() {
        clearTimeout(debounceTimeout2);
        debounceTimeout2 = setTimeout(() => {
            let inputValue = bibNo.val().trim();

            if (EVENT_ID) {
                let condition = /^[A-Za-z\s]+$/.test(bibNo);
                if (condition) {
                    if (inputValue.length >= 3) {
                        runnerNameAutoComplete();
                    }
                } else {
                    if (inputValue.length >= 1) {
                        runnerNameAutoComplete();
                    }
                }
            } else {
                if (bibNo.data("ui-autocomplete")) {
                    bibNo.autocomplete("close");
                }
            }
        }, 0);
    }

    bibNo.on("input", () => {
        setRunnerNameAutoComplete();
    });

    bibNo.on("focus", () => {
        let inputValue = bibNo.val().trim();
        if (EVENT_ID) {
            let condition = /^[A-Za-z\s]+$/.test(bibNo);
            if (condition) {
                if (inputValue.length >= 3) {
                    if (cachedParticipantList && cachedParticipantList.length > 0) {
                        bibNo.autocomplete({
                            source: function (request, response) {
                                response(cachedParticipantList);
                            }
                        });
                        bibNo.autocomplete("search", inputValue);
                    }
                }
            } else {
                if (inputValue.length >= 1) {
                    if (cachedParticipantList && cachedParticipantList.length > 0) {
                        bibNo.autocomplete({
                            source: function (request, response) {
                                response(cachedParticipantList);
                            }
                        });
                        bibNo.autocomplete("search", inputValue);
                    }
                }
            }
        } else {
            if (bibNo.data("ui-autocomplete")) {
                bibNo.autocomplete("close");
            }
        }
    });

    function runnerNameAutoComplete() {
        if (autocompleteInitialized && bibNo.autocomplete("instance")) {
            bibNo.autocomplete("destroy");
        }

        bibNo.autocomplete({
            source: function (request, response) {

                let inputValue = bibNo.val().trim();

                let condition = /^[A-Za-z\s]+$/.test(inputValue);
                if (condition) {
                    if (inputValue.length < 3) {
                        response([]);
                        return;
                    }
                } else {
                    if (inputValue.length < 1) {
                        response([]);
                        return;
                    }
                }

                if (cachedParticipantList && inputValue === lastSearchedParticipant) {
                    response(cachedParticipantList);
                    return;
                }

                axios.get('frontend/api/live-result/event-bibs', {
                    params: {
                        term: bibNo.val(),
                        event_id: EVENT_ID,
                    }
                }).then(res => {
                    // var data = res.data;
                    let decodedData = atob(res.data.data);
                    let data = JSON.parse(decodedData);
                    cachedParticipantList = data.participants.length === 0 ? [{ label: "No Runners Found", value: null }] : data.participants.map((participant) => ({
                        label: participant.highlight ? `${participant.highlight}  (${participant.bibno})` : `${participant.full_name}  (${participant.bibno})`,
                        value: participant.bibno,
                    }));
                    lastSearchedParticipant = inputValue;
                    response(cachedParticipantList);
                    $(".ui-autocomplete").each(function () {
                        $(this).toggleClass("ac-scroll-enabled", cachedParticipantList.length > 5);
                    });
                }).catch(error => {
                    console.error("API call error:", error);
                    response([]);
                    Swal.fire({
                        icon: 'info',
                        title: 'Something Went Wrong',
                        text: '',
                    });
                });
            },
            minLength: 1,
            autoFocus: false,
            open: function () {
                var parentWidth = bibNo.outerWidth();
                $("ul.ui-menu").width(parentWidth);
                $("ul.ui-menu").css("z-index", "999");
            },
            select: function (event, ui) {
                if (!ui.item.value || ui.item.value == "No Runners Found") {
                    return false;
                }
                bibNo.val(ui.item.value);
                eventForm.submit();
            }
        });

        bibNo.autocomplete("instance")._renderItem = function (ul, item) {
            return $("<li>")
                .append($("<div>").html(item.label))
                .appendTo(ul);
        };

        autocompleteInitialized = true;

        bibNo.autocomplete("search", bibNo.val());
    }

    eventForm.on("submit", (e) => {
        e.preventDefault();
        var bib_no = bibNo.val();
        if (!EVENT_ID || !bib_no) {
            return false;
        }

        if (isNaN(bib_no)) {
            return false;
        }

        loadingDiv.show();
        resultDiv.hide();

        axios.get('frontend/api/event/live-result/bib', {
            params: {
                event_id: EVENT_ID,
                bib_no: bib_no
            }
        }).then(response => {
            // var data = response.data
            // console.log("response : ", response);
            let decodedData = atob(response.data.data);
            let data = JSON.parse(decodedData);
            // console.log(data);
            if (data.status) {
                $("#username").html(data.entry_results.results_first_name + ' ' + data
                    .entry_results.results_last_name);
                $("#userbib").html(+data.entry_results.results_bib);
                $("#userevent").html(data.entry_results.results_event_name);
                $("#userracedate").html(data.entry_results.results_race_date);
                $("#userevent2").html(data.entry_results.results_event_name);
                $("#userracedate2").html(data.entry_results.results_race_date);
                $("#userracename").html(data.entry_results.results_race_name);
                let $finishtime = data.entry_results.results_time.split(".");
                $("#userfinishtime").html($finishtime[0]);
                $("#userpace").html(data.entry_results.results_pace);
                $("#userletter1").html(data.entry_results.results_user_letter);
                $("#userletter2").html(data.entry_results.results_user_letter);
                var flag = data.entry_results.results_country_code;
                // console.log("flag : ", flag);
                if (flag) {
                    var flagUrl = "/frontend/flags/4x3/" + flag.toLowerCase() + ".svg";
                    // console.log("flagUrl : ", flagUrl);
                    fetch(flagUrl)
                        .then(response => {
                            if (response.ok) {
                                userDiv1.show();
                                userDiv2.hide();
                                imgElement.attr("src", flagUrl);
                                imgElement.show();
                            } else {
                                userDiv1.hide();
                                userDiv2.show();
                                imgElement.hide();
                            }
                        })
                        .catch(error => {
                            imgElement.hide();
                        });
                } else {
                    userDiv1.show();
                    imgElement.hide();
                }

                resultDiv.show();
                loadingDiv.hide();
            } else {
                loadingDiv.hide();
                Swal.fire({
                    icon: 'info',
                    title: 'Runner Not Found',
                    // text: text,
                });
                // alert('Runner Not Found');
            }
        }).catch(error => {
            loadingDiv.hide();
            console.error("API call error:", error);
            // alert('Something Went Wrong');
            Swal.fire({
                icon: 'error',
                title: 'Something Went Wrong',
                // text: text,
            });
        });
    });
});

// home and live server search submit btn ui update
document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('.index-eventname-input-live, .index-bib-input');
    const searchBtn = document.querySelector('.event-input-searchbtn-live');

    inputs.forEach(input => {
        input.addEventListener('input', function () {
            if (this.value.trim() !== '') {
                searchBtn.classList.add('active');
            } else {
                let anyInputHasValue = false;
                inputs.forEach(inp => {
                    if (inp.value.trim() !== '') {
                        anyInputHasValue = true;
                    }
                });
                if (!anyInputHasValue) {
                    searchBtn.classList.remove('active');
                }
            }
        });

        input.addEventListener('focus', function () {
            searchBtn.classList.add('active');
        });

        input.addEventListener('blur', function () {
            let anyInputHasValue = false;
            inputs.forEach(inp => {
                if (inp.value.trim() !== '') {
                    anyInputHasValue = true;
                }
            });
            if (!anyInputHasValue) {
                searchBtn.classList.remove('active');
            }
        });
    });
});